import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { upsertStudy } from '../apis/mockDbCrud';


const Studies = () => {
  const [status, setStatus] = useState('yellow');
  const [file, setFile] = useState(null);
  const [success, setSuccess] = useState(false);

  const formik = useFormik({
    initialValues: {
      studyName: '',
      site: '',
      coordinator: '',
    },
    validationSchema: Yup.object({
      studyName: Yup.string().required('Study name is required'),
      site: Yup.string().required('Site is required'),
      coordinator: Yup.string(),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        await upsertStudy({
          input: {
            name: values.studyName,
            sites: [values.site],
            status,
            coordinator: values.coordinator,
            protocol_file: file?.name || null
          }
        });
        setSuccess(true);
        resetForm();
        setFile(null);
        setTimeout(() => setSuccess(false), 5000);
      } catch (error) {
        console.error('Failed to save study:', error);
      }
    },
  });

  return (
    <div className="container py-5" style={{ maxWidth: '600px' }}>
      <h3 className="mb-4">New Study</h3>

      {success && (
        <div className="alert alert-success" role="alert">
          ✅ Study has been created successfully!
        </div>
      )}

      <form onSubmit={formik.handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Study name</label>
          <input
            name="studyName"
            className={`form-control ${formik.touched.studyName && formik.errors.studyName ? 'is-invalid' : ''}`}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.studyName}
            placeholder="Start typing..."
          />
          {formik.touched.studyName && formik.errors.studyName && (
            <div className="invalid-feedback">{formik.errors.studyName}</div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label">Sites</label>
          <input
            name="site"
            className={`form-control ${formik.touched.site && formik.errors.site ? 'is-invalid' : ''}`}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.site}
            placeholder="Start typing..."
          />
          {formik.touched.site && formik.errors.site && (
            <div className="invalid-feedback">{formik.errors.site}</div>
          )}
          <small className="text-primary" style={{ cursor: 'pointer' }}>+ Add new</small>
        </div>

        <div className="mb-3">
          <label className="form-label">Status</label>
          <div className="d-flex gap-2">
            <button type="button" className={`btn btn-outline-success ${status === 'green' ? 'active' : ''}`} onClick={() => setStatus('green')}>Green</button>
            <button type="button" className={`btn btn-outline-warning ${status === 'yellow' ? 'active' : ''}`} onClick={() => setStatus('yellow')}>Yellow</button>
            <button type="button" className={`btn btn-outline-danger ${status === 'red' ? 'active' : ''}`} onClick={() => setStatus('red')}>Red</button>
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">Coordinator</label>
          <input
            name="coordinator"
            className="form-control"
            onChange={formik.handleChange}
            value={formik.values.coordinator}
            placeholder="Start typing..."
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Upload protocol</label>
          <input
            type="file"
            className="form-control"
            accept=".pdf,.docx,.txt"
            onChange={(e) => setFile(e.target.files[0])}
          />
        </div>

        <button type="submit" className="btn btn-primary w-100">Create Study</button>
      </form>
    </div>
  );
};

export default Studies;
